const MINUTE = 60
const HOUR = 60 * MINUTE
const DAY = 24 * HOUR
const WEEK = 7 * DAY

/** Short relative timestamp: `now`, `5m`, `3h`, `2d`, `4w`, then a date. */
export function relativeTime(seconds: number, nowSeconds = Math.floor(Date.now() / 1000)): string {
  const diff = Math.max(0, nowSeconds - seconds)
  if (diff < 45) return "now"
  if (diff < HOUR) return `${Math.round(diff / MINUTE)}m`
  if (diff < DAY) return `${Math.round(diff / HOUR)}h`
  if (diff < WEEK) return `${Math.round(diff / DAY)}d`
  if (diff < 4 * WEEK) return `${Math.round(diff / WEEK)}w`
  return formatDate(seconds)
}

export function formatDate(seconds: number): string {
  const date = new Date(seconds * 1000)
  return date.toLocaleDateString(undefined, {
    year: date.getFullYear() === new Date().getFullYear() ? undefined : "numeric",
    month: "short",
    day: "numeric",
  })
}

export function formatDateTime(seconds: number): string {
  return new Date(seconds * 1000).toLocaleString(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  })
}

/** "3 days ago" style text used in tooltips. */
export function longRelativeTime(
  seconds: number,
  nowSeconds = Math.floor(Date.now() / 1000),
): string {
  const diff = Math.max(0, nowSeconds - seconds)
  if (diff < MINUTE) return "just now"
  const units: Array<[number, Intl.RelativeTimeFormatUnit]> = [
    [MINUTE, "minute"],
    [HOUR, "hour"],
    [DAY, "day"],
    [WEEK, "week"],
    [4 * WEEK, "month"],
    [52 * WEEK, "year"],
  ]
  const formatter = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" })
  for (let index = 0; index < units.length; index += 1) {
    const [size, unit] = units[index]
    if (diff < size * (index === 0 ? 60 : 1) || index === units.length - 1) {
      return formatter.format(-Math.floor(diff / size), unit)
    }
  }
  return formatter.format(-Math.floor(diff / (52 * WEEK)), "year")
}

export function nowSeconds(): number {
  return Math.floor(Date.now() / 1000)
}
